export default {    
    Java: `import java.util.Scanner;
    public class Fibonnaci{
        public static void main(String args[]) {
            Scanner myObj = new Scanner(System.in);
            System.out.println("Type the maximum number:");
            int n = myObj.nextInt();
            
            int sum = 0;
            int term1 = 1;  
            int term2 = 1;  
            while (term2 <= n) {
                        term2 = term1 + term2;
                        term1 = term2 - term1;
                        if (term2 % 2 == 0){
                            sum += term2;
                        }
            }
            System.out.println(Integer.toString(sum));
        }
}`,
    JavaScript: `function runner(MaxLimit){
            let term1 = 1, term2 = 1, sum = 0
            while (term2 < MaxLimit){
                term2 = term1 + term2
                term1 = term2 - term1
                if (term2 % 2 == 0){
                    sum += term2
                }
            }
            console.log(sum)
        }
        runner(4000000)
}`,
    Python: `sum = 0; term1 = 1; term2 = 1; max = 4000000
while term2 < max:
    if term2 % 2 == 0: 
        sum += term2
    term1, term2 = term2, term1 + term2
print sum
`
}

